import React from "react";
import NavSide from "../containers/NavSide.jsx";

export default function Jupyter() {
  return (
    <div>
      <div className="w-full flex pt-20 bg-slate-600 min-h-screen">
        <NavSide />
        <div className="ml-44 mt-8 p-4 w-3/12 rounded-lg border border-slate-400 h-64">
          <h3 className="font-semibold text-white mt-2 text-2xl">
            Jupyter notebook
          </h3>
          <p className="text-neutral-200 text-sm mr-2 mt-2 mb-4">
            For run your Jupyter notebook service click here.
          </p>
          <div className="bg-yellow-500 p-2 mt-24 cursor-pointer hover:bg-yellow-600 rounded-lg text-center text-white font-bold">
            <a href="http://dashboard.jlab.310.ai/lab?token=68fc60da05872395040c3120ed065abd09b3a1893f51039a">
              Jupyter notebook
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
